import SelectField from '@/Vue/fields/SelectField';
import InputField from '@/Vue/fields/InputField';
export default {
  components: {
    SelectField,
    InputField,
  },
};
